import script from "./CustomInstructions.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomInstructions.vue?vue&type=script&setup=true&lang=js"

import "./CustomInstructions.vue?vue&type=style&index=0&id=5a5c1fbe&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a5c1fbe"]])

export default __exports__